import { useState, useEffect, useRef } from 'react';

export default function useElementHeight(): [React.RefObject<HTMLDivElement>, number] {
  const [height, setHeight] = useState(0);
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries: ResizeObserverEntry[]) => {
      for (const entry of entries) {
        setHeight(entry.contentRect.height);
      }
    });

    if (elementRef.current) {
      resizeObserver.observe(elementRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [elementRef]);

  return [elementRef, height];
}
